import React from "react";
import { Link } from "react-router-dom";
import { HiArrowUpRight } from "react-icons/hi2";

export default function CTA() {
  return (
    <section className="section" id="contact">
      <div className="container-x">
        <div className="cta reveal">
          <span className="eyebrow">Let's collaborate</span>
          <h2 className="cta__title">
            Got a project?
            <br />
            <span className="it accent">Let's make it real.</span>
          </h2>
          <p className="cta__sub">
            Whether it's a Shopify rebuild, a new web app or a tricky API —
            tell me about it. I read every message.
          </p>
          <div className="hero__cta" style={{ justifyContent: "center" }}>
            <Link className="btn btn--lg" to="/contact">
              Start a conversation
              <span className="arrow"><HiArrowUpRight /></span>
            </Link>
            <a
              className="btn btn--ghost btn--lg"
              href="https://www.linkedin.com/in/oguzhanozcelik/"
              target="_blank"
              rel="noreferrer noopener"
            >
              LinkedIn
              <span className="arrow"><HiArrowUpRight /></span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
